var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#6B2B90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1353 2.0917C23.6462 1.64684 28.1676 2.82934 31.8831 5.42572C32.3179 5.72955 32.6142 6.19366 32.7068 6.71595C32.7994 7.23823 32.6808 7.77592 32.3769 8.21071L32.3672 8.22465C31.7345 9.13006 30.4876 9.35114 29.5822 8.71845C26.6522 6.67099 23.0868 5.7385 19.5295 6.08931C15.9723 6.44011 12.6577 8.05111 10.1841 10.6315C7.71047 13.2118 6.24085 16.5915 6.04055 20.1604C5.84024 23.7292 6.92244 27.2521 9.09177 30.0931C11.2611 32.934 14.3746 34.9058 17.8703 35.6525C21.3659 36.3991 25.0133 35.8714 28.154 34.1647C31.2947 32.458 33.7218 29.6847 34.997 26.3454C36.2723 23.0061 36.3117 19.321 35.1082 15.9552C34.7363 14.9151 35.2779 13.7705 36.318 13.3986L36.334 13.3928C36.8335 13.2142 37.3834 13.2414 37.8629 13.4682C38.3423 13.6951 38.712 14.1032 38.8906 14.6026C40.4168 18.8708 40.3668 23.544 38.7497 27.7785C37.1325 32.013 34.0548 35.5299 30.072 37.6942C26.0893 39.8585 21.464 40.5277 17.0312 39.5808C12.5984 38.634 8.65007 36.1336 5.89913 32.531C3.14819 28.9284 1.77585 24.461 2.02986 19.9353C2.28387 15.4096 4.14749 11.1238 7.28429 7.85162C10.4211 4.57947 14.6244 2.53656 19.1353 2.0917Z",
    fill: "#33CDAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0793 6.77285C39.757 7.64508 39.5993 8.90155 38.7271 9.57927C31.5557 15.1515 27.9515 19.2045 22.2271 29.0084C21.8773 29.6075 21.242 29.9826 20.5484 29.9994C19.8549 30.0162 19.2021 29.6723 18.8237 29.0909C16.7758 25.9439 15.3086 24.5 11.8716 22.1512C10.9596 21.528 10.7255 20.2835 11.3487 19.3715C11.972 18.4596 13.2165 18.2255 14.1284 18.8487C16.929 20.7626 18.6778 22.2466 20.3508 24.3474C25.468 15.978 29.3445 11.804 36.2729 6.42067C37.1451 5.74295 38.4016 5.90063 39.0793 6.77285Z",
    fill: "#33CDAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProCheck);
export default __webpack_public_path__ + "static/media/pro_check.e2bd69d8d2a766c00838a29834e69d7e.svg";
export { ForwardRef as ReactComponent };